(() => {
  const railSelector = [
    '.zyvoria-category-editorial__grid',
    '.index-tab-collections--sticky-feature .zyvoria-sticky-collection__products.grid--mobile-slider',
    '[id$="home_best_sellers"] .grid--mobile-slider',
    '[id$="home_summer_edit"] .grid--mobile-slider',
    '.template-product .product__images--mobile-slider .product__slides',
  ].join(',');

  const attachProgress = (rail) => {
    if (rail.dataset.zyvoriaProgressReady === 'true') return;
    rail.dataset.zyvoriaProgressReady = 'true';

    const progress = document.createElement('div');
    const thumb = document.createElement('span');
    progress.className = 'zyvoria-scroll-progress';
    progress.setAttribute('aria-hidden', 'true');
    thumb.className = 'zyvoria-scroll-progress__thumb';
    progress.appendChild(thumb);
    rail.insertAdjacentElement('afterend', progress);

    let frame;
    const update = () => {
      frame = null;
      const range = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const trackWidth = progress.clientWidth;
      const thumbWidth = Math.max(38, trackWidth * Math.min(1, rail.clientWidth / rail.scrollWidth));
      const offset = range > 0
        ? (rail.scrollLeft / range) * Math.max(0, trackWidth - thumbWidth)
        : 0;

      progress.hidden = range < 2;
      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${offset}px)`;
    };

    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    rail.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(requestUpdate).observe(rail);
    }

    requestUpdate();
  };

  const initialize = (root = document) => {
    root.querySelectorAll(railSelector).forEach(attachProgress);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
